import moment from "moment-timezone";

export const isEndType = (dropType) => dropType === "end";

export const getPreviousHalfHourLabel = (timezone = "UTC") => {
  const current = moment.tz(timezone);
  const minute = current.minute();
  const roundedMinute = minute === 0 ? 0 : Math.floor(minute / 30) * 30;
  return current.clone().startOf("hour").add(roundedMinute, "minutes").format("HH:mm");
};

export const isBookingOngoingInTimezone = (booking, timezone = "UTC") => {
  const dateFrom = booking?.start || booking?.dateFrom;
  const dateTo = booking?.end || booking?.dateTo;
  if (!dateFrom || !dateTo) return false;

  const nowUtc = moment.tz(timezone).utc();
  return nowUtc.isAfter(moment(dateFrom).utc()) && nowUtc.isBefore(moment(dateTo).utc());
};
